"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEST_ID = exports.LoadingIndicator = void 0;
var _react = _interopRequireDefault(require("react"));
var _Spinner = require("./Spinner");
require("./LoadingIndicator.css");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var TEST_ID = exports.TEST_ID = {
  CONTAINER: 'loading-indicator-container',
  SPINNER: 'loading-indicator-spinner',
  TEXT: 'loading-indicator-text'
};
var LoadingIndicator = _ref => {
  var className = _ref.className,
    text = _ref.text,
    _ref$spinnerPosition = _ref.spinnerPosition,
    spinnerPosition = _ref$spinnerPosition === void 0 ? 'bottom' : _ref$spinnerPosition;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('zui-loading-indicator', "zui-loading-indicator-".concat(spinnerPosition), className),
    "data-testid": TEST_ID.CONTAINER
  }, /*#__PURE__*/_react.default.createElement(_Spinner.Spinner, {
    "data-testid": TEST_ID.SPINNER
  }), text && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('zui-loading-indicator-text', "zui-loading-indicator-text-".concat(spinnerPosition)),
    "data-testid": TEST_ID.TEXT
  }, text));
};
exports.LoadingIndicator = LoadingIndicator;
//# sourceMappingURL=LoadingIndicator.js.map